import { supabase } from "@/infrastructure/supabase/client";
import type { ComponentCriticalityRow } from "@/infrastructure/supabase/database.types";

export interface UpsertComponentCriticalityInput {
  component_id: string;
  criticality: number;
}

export const componentCriticalityRepository = {
  async list(): Promise<ComponentCriticalityRow[]> {
    const { data, error } = await supabase.from("component_criticality").select("*");
    if (error) throw error;
    return data ?? [];
  },

  async upsert(input: UpsertComponentCriticalityInput): Promise<ComponentCriticalityRow> {
    const { data, error } = await supabase
      .from("component_criticality")
      .upsert(input, { onConflict: "component_id" })
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(componentId: string): Promise<void> {
    const { error } = await supabase
      .from("component_criticality")
      .delete()
      .eq("component_id", componentId);
    if (error) throw error;
  },
};
